import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NonTransactionalFlowService } from 'app/infrastructure/services/non-transactional-flow.service';
import { NonTransactionalFlow, BasicPageInfo } from 'app/infrastructure/model/interfaces/non-transactional-flow.interface';
import { FlowElement } from 'app/infrastructure/services/productFlow.service';
import { GrowlType, AlertService } from 'app/infrastructure/services/alert.service';
import { RuleService } from 'app/infrastructure/services/reglas.service';
import { ConfirmacionModalComponent } from 'app/helpers/components/confirmationModal/confirmationModal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: './non-transactional-flow.component.html',
})
export class NonTransactionalFlowComponent implements OnInit {
  constructor(
    private router: Router,
    private aRoute: ActivatedRoute,
    private reglasService: RuleService,
    private nonTransactionalFlowSrv: NonTransactionalFlowService,
    private alertService : AlertService,
    private modalService: NgbModal
    ) {}

  flows: NonTransactionalFlow[];
  description: string;
  flowId: string;
  newPageId: string;
  pages: BasicPageInfo[];
  interactionEvents: FlowElement[];

  preguntarSiDeseaBorrarRule = [];
  preguntarSiDeseaBorrarPage =[];
  searchInteractionRule: string;

  preguntarSiDeseaBorrar = [];

  ngOnInit(): void {
    this.aRoute.params.subscribe((params) => {
      this.flowId = params['flowId'];
      if (!this.flowId)
        this.nonTransactionalFlowSrv.getAll().subscribe((flows) => {
          this.flows = flows;
        });
      else
      {
        this.nonTransactionalFlowSrv.getFlowPages(this.flowId).subscribe(pages => this.pages = pages);
        this.nonTransactionalFlowSrv.getNonTransactionalRules(this.flowId).subscribe(pages => this.interactionEvents = pages);
      } 
    });
  }

  createNewFlow(): void {
    if (this.description != null && this.description !== '')
    {
      this.nonTransactionalFlowSrv
        .createNonTransactionalFlow({ Description: this.description })
        .subscribe((id) => {
          this.goToFlow(id);
        });
    }else{
      this.alertService.showGrowl({
        type: GrowlType.DANGER,
        body: `DESCRIPTION_MUST_BE_SET`,
      });
    }
  }

  createNewPage(): void {
    this.goToPage(this.newPageId);
  }

  goToPage(pageId): void {
    this.router.navigate([`./designer/${pageId}`], { relativeTo: this.aRoute });
  }
  
  goToFlow(id: string): void {
    this.router.navigate([`./${id}`], { relativeTo: this.aRoute });
  }

  clickDeleteInteractionRule(name:string){
    this.reglasService.delete(name).then((x) => {
        this.nonTransactionalFlowSrv.getNonTransactionalRules(this.flowId)
        .subscribe(pages => this.interactionEvents = pages);
      this.alertService.showGrowl({
        type: GrowlType.SUCCESS,
        body: `INTERACTION_RULE_REMOVED`,
      });
    });
  }

  clickDeletePage(id:string){
    this.nonTransactionalFlowSrv
    .detelePage({ id : this.flowId,pageId : id })
    .then((_) => {
      this.nonTransactionalFlowSrv.getFlowPages(this.flowId).subscribe(pages => this.pages = pages);
      this.alertService.showGrowl(
        {
          type: GrowlType.SUCCESS,
          body: 'SUCCESSFUL_DELETE_PAGE_WITH_ID',
        },
        { pageId: id }
      );
  });
  }

  onClickNewInteractionRule(){
    this.router.navigate(
      ['.', 'interactionEvent', 'InteractionEvent', 'NewRule'],
      { relativeTo: this.aRoute }
    );
  }

  clickEditInteractionRule(ruleCommand: string) {
    this.router.navigate(
      ['.', 'interactionEvent', 'InteractionEvent', ruleCommand],
      { relativeTo: this.aRoute }
    );
  }

  clickDeleteFlow(id: string) {
    this.nonTransactionalFlowSrv
    .deleteFlow(id)
    .subscribe((id) => {
      this.nonTransactionalFlowSrv.getAll().subscribe((flows) => {
        this.flows = flows;
      });
      this.alertService.showGrowl({
        type: GrowlType.SUCCESS,
        body: `NON_TRANSACTIONAL_FLOW_REMOVED`,
      });
    });
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/non-transactional-flow/non-transactional-flow.component.ts